
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ExtraDossiersMetaData} from "@/models/module-extra-dossiers-meta-data";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";

export default FormLike.extend({
	data(){
		return {
			count: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.count = ExtraDossiersMetaData.create(this.value.metaData).getExtraDossiers();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			ExtraDossiersMetaData.create(this.value.metaData).setExtraDossiers(this.count);
			await CompanyService.updateModuleOfCompany(this.company, this.value.id, this.value.metaData);
			this.$emit("saved", this.value);
			this.$emit("close");
		}
	}
});
